import { Button } from '@nrx/ui';
import type { JSX } from 'react';

import { SupportContact } from './support-contact.js';

/**
 * Terminal "you're already enrolled" block for a cross-program `existing_member` eligibility
 * result. No coverage details, no enroll CTA, no booking — just the approved copy pointing to
 * support, with a way back to the form in case the match was a mistake.
 */
export function ExistingMemberSupport({ onReset }: { onReset: () => void }): JSX.Element {
  return (
    <div className="flex flex-col gap-4">
      <h2 className="text-xl font-semibold text-[var(--forest)]">We’ve met before!</h2>
      <p className="text-lg leading-relaxed text-[var(--ink)]">
        You may be or have been eligible for another NourishedRx program. This consult option is not
        currently available to you.
      </p>
      <SupportContact />
      {/* Secondary, not primary: this screen is a hard stop, and the intended next step is the
          support contact above — not another attempt. */}
      <Button className="self-start" tone="secondary" onClick={onReset}>
        Not you? Start over
      </Button>
    </div>
  );
}
